import { render, staticRenderFns } from "./ListKlaimCCPd.vue?vue&type=template&id=4f8b6adc&"
import script from "./ListKlaimCCPd.vue?vue&type=script&lang=js&"
export * from "./ListKlaimCCPd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports